import {Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import { UserService } from '../services/user.service';

@Injectable()
export class UriInterceptor implements HttpInterceptor {

   constructor(private userService: UserService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf('assets') < 0) {
      let headers = req.headers;
      headers = headers.set('Content-Type', 'application/json');
      headers = headers.set('Authorization',  `${this.userService.getTokenType()} ${this.userService.getUserAccessToken()}`);

      const uriReq = req.clone({
        headers,
        url: environment.api_uri + '/' + req.url
      });
      return next.handle(uriReq);
    }

    return next.handle(req);
  }
}
